<script>
export default {
	lang: 'shop',
	props: {
		order: Object,
	},
	computed: {
		email() {
			return this.order.user.accountEmail
		},
	},
}
</script>

<template>
	<div>
		<div class="d-flex align-center">
			<v-icon left small>mdi-email</v-icon>
			<b>Email</b>
		</div>
		<div>{{ email }}</div>
	</div>
</template>

